export const EN = 'en';
export const DEFAULT_LOCALE = EN;
export const LOCALES = [EN];
